import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ClientAccount } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = ClientAccount;

export const useClientAccount = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query clientAccount {
      clientAccount {
        id
        name
        paymentMethod
        usedTargetLanguages
        allOrderableTargetLanguages {
          name
          code
        }
        languagePairs {
          description
          sourceLanguageCode
          targetLanguageCode
        }
        orderableQualities
        users {
          id
          name
          firstName
          lastName
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['clientAccount'],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql
        }
      })
  });
};
